import { Box } from "@chakra-ui/layout";
import type { UtilizationReportGroupOrderByColumn } from "@src/__generated__/graphql";
import type { UtilizationReportStore } from "@src/components/modules/reports/utilization/stores/utilization-report";
import { DataTable, LoadingOverlay } from "@src/components/ui-kit";
import { Pagination } from "@src/components/ui-kit/table/pagination";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import {
  type UtilizationGroupedTableRow,
  useUtilizationGroupedTableCols,
} from "../hooks/groupedTableCols";

type Props = {
  store: UtilizationReportStore;
};
export const GroupByTable = observer(function GroupByTable({ store }: Props) {
  const cols = useUtilizationGroupedTableCols(store);
  const data = useMemo<UtilizationGroupedTableRow[]>(
    () =>
      store.tableGroupedByData.map(({ group_title, report, items }, index) => ({
        id: index.toString(),
        rowType: "group",
        group_title,
        report,
        items,
        __subRows: items.map(({ report: itemReport, user }, itemIndex) => ({
          id: `${index}-${itemIndex}`,
          rowType: "item",
          group_title,
          report: itemReport,
          user,
          items,
        })),
      })) ?? [],
    [store.tableGroupedByData],
  );

  if (!cols) return null;

  return (
    <Box position="relative">
      <LoadingOverlay
        isLoading={store.isReportGroupedByLoading}
        position="absolute"
        size="lg"
      >
        <DataTable.Body<
          UtilizationGroupedTableRow,
          UtilizationReportGroupOrderByColumn
        >
          tableKey={`${store.moduleKey}-grouped-by`}
          data={data}
          columns={cols}
          orderedBy={store.activeOrderByGrouped}
          onOrderByChange={store.handleChangeOrderByGrouped}
        />
      </LoadingOverlay>

      <Pagination store={store.pagination} />
    </Box>
  );
});
